import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Court } from './court';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourtService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Court[]> {
    return this.httpClient.get<Court[]>(this.baseUrl + 'api/CourtApi')
  }
  Post(court: Court): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/CourtApi/Add', court, { headers: header, observe: 'response' })
  }
  Delete(court: Court) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/CourtApi/activeordeactive', court, { headers: header, observe: 'response' })
  }
  Put(court: Court): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/CourtApi/Update', court, { headers: header, observe: 'response' })
  }


}
